module.exports = __webpack_public_path__ + "img/colors.72f0ccdc.svg";